import axios from 'axios'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import Logger from 'core/utils/Logger'
import { ENDPOINT_EXPORT_SPR } from 'src/config/url'

import { downloadEmulate } from '../../../helpers/downloadEmulate'

type DataExport = {
  companyName?: string
  country?: string
  taxId?: string
}

export async function exportData(data: DataExport) {
  const [token] = getTokens()

  try {
    const res = await axios({
      url: ENDPOINT_EXPORT_SPR,
      headers: {
        Authorization: `${token}`,
      },
      method: 'POST',
      responseType: 'blob',
      data,
    })
    const fileName = `${Date.now()}_${[data.companyName, data.country, data.taxId]
      .filter((it) => it)
      .join('_')}.xlsx`

    const blob = new Blob([res.data])
    downloadEmulate(fileName, blob)
  } catch (e) {
    Logger.error(e)
  }
}
